import React from 'react';
import { answersList } from './AnswersList.module.css';
import AnswerItem from './AnswerItem';
import nextId from 'react-id-generator';

const AnswersList = ({ onAnswerClick, state, answers }) => (
  <ul className={answersList}>
    {answers.map(answer => {
      const { id } = answer
      return (
        <AnswerItem
          key={nextId()}
          answer={answer}
          onAnswerClick={onAnswerClick}
          state={state && state[id]}
        />
      )
    })}
  </ul>
)

export default AnswersList